import React from "react";
import './BlockHeader.css';

const BlockHeader = ({
  icon,
  iconTitle,
  iconAlt,
  title,
  cname
}) => {
  return (
    <div
      className={`mydevices-block-header-wrapper${
        cname ? ` ${cname}` : ''
      }`}
    >
      <img src={icon} title={iconTitle} alt={iconAlt} />
      <span>{title}</span>
    </div>
  );
};


export default BlockHeader;